import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Chip (a filter, pressable) and Tag (a static label) — §4.
 *
 * A filter chip is a **toggle**, so it is React Aria's `ToggleButton`: independently
 * pressable, `aria-pressed` for free, and `data-selected` / `data-hovered` /
 * `data-focus-visible` for the sheet's states.
 *
 * Deliberately **not** a `TagGroup`: a tag group owns one selection across its children and
 * would have replaced `ChipProps` with a collection API. The chips here belong to whatever
 * row happens to hold them, and each one is its own yes/no.
 */
import { ToggleButton } from 'react-aria-components';
import { TickGlyph } from '../glyphs.js';
export function Chip({ pressed = false, count, children, ...rest }) {
    return (_jsxs(ToggleButton, { ...rest, isSelected: pressed, className: "chip-f", children: [_jsx(TickGlyph, { className: "ck tick" }), _jsx("span", { children: children }), count !== undefined && _jsx("span", { className: "n", children: count })] }));
}
export function Tag({ children }) {
    return _jsx("span", { className: "tag", children: children });
}
//# sourceMappingURL=Chip.js.map